import { Sidebar } from 'primereact/sidebar'
import React, { useMemo } from 'react'
import { NavLink } from 'react-router-dom'

import { sidebarLinks } from '../../utils/sidebarLinks'
import CheckPermission from '../../hooks/CheckPermission'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const MobileSibeBar = ({ openMobileSidebar, setOpenMobileSidebar }) => {
  const { hasPermission } = CheckPermission()
  const loggedUser = useSelector(state => state?.auth?.user)
  const isReceptionist = loggedUser?.role?.name_en === 'Receptionist'
  const isAdmin = loggedUser?.role?.name_en === 'Admin'
  const isManager = loggedUser?.role?.name_en === 'manager'
  const isAccountant = loggedUser?.role?.name_en === 'Accountant'
  const isRcmAssistant = loggedUser?.role?.name_en === 'Rcm Assistant'
  const isNurse = loggedUser?.role?.name_en === 'Nurse'
  const isPractitioner = loggedUser?.role?.name_en === 'Practitioner'
  const { t } = useTranslation()

  const allLinks = useMemo(() => {
    const links = sidebarLinks(
      t,
      isReceptionist,
      isAdmin,
      isManager,
      loggedUser,
      isAccountant,
      isNurse,
      isPractitioner,
      isRcmAssistant
    )

    return isRcmAssistant
      ? links?.filter(item => item?.moduleName !== 'visit')
      : links
  }, [
    t,
    isReceptionist,
    isAdmin,
    isManager,
    loggedUser,
    isAccountant,
    isNurse,
    isPractitioner,
    isRcmAssistant
  ])
  const customHeader = (
    <div className='flex align-items-center gap-2'>
      <img
        src='/images/supergit-03.png'
        alt='logo'
        className='h-[50px] w-[50px]'
      />
    </div>
  )
  const isCallCenter = loggedUser?.role?.name_en === 'Call Center'
  return (
    <div>
      <Sidebar
        visible={openMobileSidebar}
        header={customHeader}
        onHide={() => setOpenMobileSidebar(false)}
        pt={{
          root: { className: 'w-[300px] rounded !bg-primary' },
          header: {
            className:
              'flex items-center justify-between border-b border-gray-800'
          },
          content: { className: 'px-0' },
          closebutton: { className: '!text-white' }
        }}
      >
        <div className='flex flex-col '>
          {allLinks?.map(
            (data, index) =>
              (hasPermission(data?.moduleName, 'get') ||
                (isCallCenter && data?.allowCallCenter)) && (
                <NavLink
                  key={index}
                  to={data?.link}
                  className='flex flex-row   text-white gap-2 group items-center pe-1 ps-3 py-3 sidebar-navlink'
                >
                  <div className='flex border border-white h-[25px] text-white justify-center rounded-full w-[25px] group-hover:bg-white group-hover:!text-primary  items-center'>
                    {data?.icon}
                  </div>
                  <p className='text-[14px] text-white font-[400] group-hover:text-white mt-1'>
                    {data?.label}
                  </p>
                </NavLink>
              )
          )}
        </div>
      </Sidebar>
    </div>
  )
}

export default MobileSibeBar
